/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'g_traffic': {
    width: 16,
    height: 16,
    viewBox: '0 0 57.21 56.69',
    data: '<path pid="0" _fill="#fff" d="M16.24 40.44h3.65v-3.06h30.89v3.06h3.64v-6.59H16.24v6.59zM52.33 19.31l-6.66-6.29H24.99l-5.3 6.28h-5.48v3.53l7.21.01 5.3-6.28h17.47l6.64 6.27 6.35.04.03-3.53-4.88-.03z"/><path pid="1" d="M29.22 53.11C15.14 53.11 3.68 42 3.68 28.34S15.14 3.58 29.22 3.58a25.69 25.69 0 0120.08 9.47l2.89-2.22a29.39 29.39 0 00-23-10.82C13.11 0 0 12.71 0 28.34s13.11 28.35 29.22 28.35a29.59 29.59 0 0023.75-11.83l-3-2.09a25.85 25.85 0 01-20.75 10.34" _fill="#fff"/><path pid="2" d="M49.95 29.69a1.35 1.35 0 111.39-1.35 1.37 1.37 0 01-1.39 1.35m-29.11 0a1.35 1.35 0 111.39-1.35 1.37 1.37 0 01-1.39 1.35m29.14-5.94a4.77 4.77 0 00-4.17 2.43H24.98a4.77 4.77 0 00-4.14-2.43 4.59 4.59 0 100 9.17 4.73 4.73 0 004.51-3.21h20.09a4.73 4.73 0 004.51 3.21 4.59 4.59 0 100-9.17" _fill="#fff"/>'
  }
})
